export function trimEndZero(src: string) {
  src = src.toString();
  if (/\.00$/.test(src)) {
    return src.replace(/\.00$/, '');
  }
  return src;
}

export function digitalToSize(digital, interval, sizes, isRounding) {
  if (digital > 0 && digital < 1) {
    return digital;
  }
  if (digital < 0 && digital > -1) {
    return digital;
  }
  if (digital === 0) return digital;
  const i = Math.floor(Math.log(digital) / Math.log(interval));

  let r: any = (digital / Math.pow(interval, i)).toPrecision(3);

  if (isRounding) {
    r = parseFloat(r);
  }
  return trimEndZero(r) + sizes[i];
}

export function moneyToSize(digital, isRounding = false) {
  return digitalToSize(digital, 1000, ['', 'k', 'm', 'b'], isRounding);
}

export const format = ($symbol, amount = null, _moneyToSize = false, noTrim = false) => {
  let symbol;

  let symbol_html = '';

  if ($symbol) {
    // symbol = api.getSymbol($symbol);
    symbol_html = `${$symbol}`;
  }
  if (amount === null) {
    return symbol_html;
  }
  let amount_num = (amount / 100).toFixed(2);

  if (amount === 0) {
    amount_num = !noTrim ? '0' : '0.00';
  }
  if (_moneyToSize) {
    amount_num = `${  moneyToSize(+amount_num, false)}`;
  }
  const amount_html = `${amount_num}`;

  return symbol_html + (!noTrim ? trimEndZero(amount_html) : amount_html);
};

export const toUsMoneyFormat = (amount) => (new Intl.NumberFormat('en-US').format(+amount).toString());
